import React, { useState, useEffect, useRef } from "react";
import "../Css/HomeItemButton.css";
import { Transition } from "semantic-ui-react";
import "../Css/Animations.css";
//import { useRef } from "react/cjs/react.production.min";

const root = document.documentElement;
function HomeItemButton({
  icon,
  hiddenTitle,
  subText,
  buttonSize = 100,
  onClick,
  delay,
}) {
  const [visible, setVisible] = useState(false);
  const [blurAmount, setBlurAmount] = useState(0);
  //const [deltaPos, setDeltaPos]=useState(0);

  const media_ref = useRef();

  var deltaPos = 0;

  root.style.setProperty("--homebtn-button-size", `${buttonSize}px`);

  const style = {
    blur: {
      WebkitFilter: "blur(" + blurAmount + "px)",
      MozFilter: "blur(" + blurAmount + "px)",
      OFilter: "blur(" + blurAmount + "px)",
      msFilter: "blur(" + blurAmount + "px)",
      filter: "blur(" + blurAmount + "px)",
    },
    popup: {
      animationDelay: delay + "s",
      //"transform": "scale("+2+")",
      animationName: "pop-enter",
      animationDuration: "1.5s",
      animationPlayState: "pause",
      animationFillMode: "forwards",
    },
  };

  const perfectFrameTime = 1 / 60;
  const offset = Math.random()*delay;
  var timeCounter = 0;
  useEffect(() => {
    floating();
  }, []);
  function floating() {
    timeCounter += perfectFrameTime;
    deltaPos = Math.sin(timeCounter * 0.5 + offset) * 30;
    if (media_ref.current) 
      media_ref.current.style.top = deltaPos + "px";

    requestAnimationFrame(floating);
  }

  return (
    <>
      <div
        className="homebtn__mainButton"
        onMouseEnter={() => {
          setVisible(true);
          setBlurAmount(5);
        }}
        onMouseLeave={() => {
          setVisible(false);
          setBlurAmount(0);
        }}
        onClick={() => (onClick ? onClick() : {})}
        style={style.popup}
        ref={media_ref}
      >
        <div className="home__btnMediaContaier">
          <img
            src={icon}
            className="homebtn__mainButtonIcon"
            style={style.blur}
          />
          {/* 淡入box */}
          <Transition visible={visible} animation="scale" duration={500}>
            <div className="homebtn__hiddenBoxContainer">
              {/* 淡入box --內容 */}
              <p className="homebtn__hiddenTitle"> {hiddenTitle} </p>
            </div>
          </Transition>
        </div>
        <p className="homebtn__subText">{subText}</p>
      </div>
    </>
  );
}

export default HomeItemButton;
